import request from '../utils/request'

/**
 * 列出消费记录
 * @param {Object} data
 */
export function ListPaymentHistory (data) {
  return request({
    url: '/pay/list_payment_history/v2',
    method: 'post',
    data
  })
}

/**
 * 微信支付
 * @param {Object} data
 */
export function payWithWechat (data) {
  return request({
    url: '/pay/with_wechat_pay',
    method: 'post',
    data
  })
}

/**
 * 免费配音次数支付
 * @param {Object} data
 */
export function payWithFreeDubbings (data) {
  return request({
    url: '/pay/with_free_dubbings',
    method: 'post',
    data
  })
}

/**
 * 余额支付接口
 * @param {String} trade_no
 * @return code
 */
export function payWithWallet (data) {
  return request({
    url: '/pay/with_wallet',
    method: 'post',
    data
  })
}

/**
 * 获取微信支付二维码
 * @param {String} trade_no
 * @return code
 */
 export function payWithWechatNativeQrcode (data) {
  return request({
    url: '/pay/with_wechat_native_qrcode',
    method: 'post',
    data
  })
}

/**
 * 获取微信支付二维码
 * @param {String} trade_no
 * @return code
 */
 export function payWithNativePay (data) {
  console.log(data, 'payWithNativePay')
  return request({
    url: '/pay/with_wechat_native_pay',
    method: 'post',
    data
  })
}
